type Props = React.SVGAttributes<SVGElement> & {
  iconColor?: string
}

export const CopyIcon = ({ iconColor, ...props }: Props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 1.5C5.17157 1.5 4.5 2.17157 4.5 3V4H3.5C2.67157 4 2 4.67157 2 5.5V13C2 13.8284 2.67157 14.5 3.5 14.5H10C10.8284 14.5 11.5 13.8284 11.5 13V12H12.5C13.3284 12 14 11.3284 14 10.5V3C14 2.17157 13.3284 1.5 12.5 1.5H6ZM11.5 11H12.5C12.7761 11 13 10.7761 13 10.5V3C13 2.72386 12.7761 2.5 12.5 2.5H6C5.72386 2.5 5.5 2.72386 5.5 3V4H10C10.8284 4 11.5 4.67157 11.5 5.5V11ZM3.5 5C3.22386 5 3 5.22386 3 5.5V13C3 13.2761 3.22386 13.5 3.5 13.5H10C10.2761 13.5 10.5 13.2761 10.5 13V5.5C10.5 5.22386 10.2761 5 10 5H3.5Z"
        fill={iconColor || '#131313'}
      />
    </svg>
  )
}
